import { useTranslation } from 'react-i18next'
import { Zap, Palette, BookOpen, Calendar, Building2 } from 'lucide-react'
import { AdminLandingCard } from './admin-landing-card'

export function AdminLanding() {
  const { t } = useTranslation()

  const sections = [
    {
      title: t('administration.sections.actions.title', 'Actions'),
      description: t('administration.sections.actions.description', 'Gérer le référentiel des actions : créer, modifier et supprimer des actions'),
      to: '/administration/actions',
      icon: Zap,
    },
    {
      title: t('administration.sections.activities.title', 'Activités'),
      description: t('administration.sections.activities.description', "Gérer le référentiel des activités : créer, modifier et supprimer des types d'activités"),
      to: '/administration/types-activite',
      icon: Palette,
    },
    {
      title: t('administration.sections.subjects.title', 'Matières'),
      description: t('administration.sections.subjects.description', 'Gérer le référentiel des matières : créer, modifier et supprimer des matières'),
      to: '/administration/matieres',
      icon: BookOpen,
    },
    {
      title: t('administration.sections.periods.title', 'Périodes'),
      description: t('administration.sections.periods.description', 'Gérer le référentiel des périodes : créer, modifier et supprimer des périodes'),
      to: '/administration/periodes',
      icon: Calendar,
    },
    {
      title: 'Structures',
      description: 'Gérer le référentiel des structures : écoles, lycées, collèges, associations',
      to: '/administration/structures',
      icon: Building2,
    },
  ]

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {sections.map((section) => (
        <AdminLandingCard
          key={section.to}
          title={section.title}
          description={section.description}
          to={section.to}
          icon={section.icon}
        />
      ))}
    </div>
  )
}
